// Existing approval events may contain an internal view index instead of a
// description. Hide only that known format; preserve human and legacy text.
export const commentDisplayBody = (entry) => {
  if (entry.kind !== 'system_note' || typeof entry.body !== 'string') return entry.body;
  return entry.body.replace(
    /^((?:Line item (?:approved|denied) by|Item (?:approuvé|refusé) par) .+?)\s*:\s*\d+(?=\s+-\s|$)/,
    '$1'
  );
};

// Scope descriptors remain server-authorized. The modal only narrows their
// presentation and uses its own line's grant for a shared expense discussion.
export const lineCommentScopes = (scopes, lineId) => {
  if (lineId === null) return scopes;
  if (!lineId) return [];
  return scopes.filter(scope => scope.section === 'lines' && (
    scope.subject.line_id === lineId || scope.invoice_line_ids?.includes(lineId)
    || scope.query?.via_line_id === lineId
  )).map(scope => scope.query?.via_invoice_id
    ? { ...scope, query: { ...scope.query, via_line_id: lineId } } : scope);
};
